module.exports = __webpack_public_path__ + "cfp/The-Art-&-Science-of-Report-Writing-Kernelcon-201904.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/The-Art-&-Science-of-Report-Writing-Kernelcon-201904.pdf
// module id = 922
// module chunks = 0